import script from "./PractitionerBio.vue?vue&type=script&lang=ts&setup=true"
export * from "./PractitionerBio.vue?vue&type=script&lang=ts&setup=true"

import "./PractitionerBio.vue?vue&type=style&index=0&id=c2456282&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2456282"]])

export default __exports__